/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { clipzyGetClipzyRaw } from "../../funcs/clipzyGetClipzyRaw.js";
import { GetClipzyRawRequest$zodSchema } from "../../models/getclipzyrawop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetClipzyRawRequest$zodSchema,
};

export const tool$clipzyGetClipzyRaw: ToolDefinition<typeof args> = {
  name: "clipzy--get-clipzy-raw",
  description: `步骤2 (方法二): 获取原始文本

**此接口用于“方便自动化”方法。**

您提供第一步获得的ID，并附上您自己保管的**解密密钥**作为 \`key\` 参数。服务器会直接为您解密，并返回纯文本内容。

> [!IMPORTANT]
> 查看文档首页的 **cURL 示例**，了解此接口最典型的用法。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await clipzyGetClipzyRaw(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
